import {
  DescribePipelineLaunchResponse,
  ListPipelinesResponse,
  DescribePipelineSchemaResponse,
  DescribePipelinesResponse,
} from '@easy-genomics/shared-lib/src/app/types/nf-tower/nextflow-tower-api';
import {
  ListPipelinesResponse as ListPipelinesResponseSchema,
  PipelineSchemaResponse as PipelineSchemaResponseSchema,
} from '@easy-genomics/shared-lib/src/app/types/nf-tower/nextflow-tower-zod-schemas.client';
import { httpClient } from '@/lib/api/client';
import { validateApiResponse, stripNullProperties } from '@/lib/api-utils';

class SeqeraPipelinesModule {
  async list(labId: string): Promise<ListPipelinesResponse> {
    const res = await httpClient.callSeqera<ListPipelinesResponse>(
      'GET',
      `/pipeline/list-pipelines?laboratoryId=${labId}`,
    );

    if (!res) {
      throw new Error('Failed to retrieve pipeline launch details');
    }

    const cleanedPipelines = stripNullProperties(res?.pipelines || []);
    const cleanedRes = { ...res, pipelines: cleanedPipelines };

    validateApiResponse(ListPipelinesResponseSchema, cleanedRes);
    return res;
  }

  async read(pipelineId: number, labId: string): Promise<DescribePipelinesResponse> {
    const res = await httpClient.callSeqera<DescribePipelinesResponse>(
      'GET',
      `/pipeline/read-pipeline/${pipelineId}?laboratoryId=${labId}`,
    );

    if (!res) {
      throw new Error('Failed to retrieve pipeline');
    }

    return res;
  }

  async readPipelineLaunchDetails(pipelineId: number, labId: string): Promise<DescribePipelineLaunchResponse> {
    const res = await httpClient.callSeqera<DescribePipelineLaunchResponse>(
      'GET',
      `/pipeline/read-pipeline-launch-details/${pipelineId}?laboratoryId=${labId}`,
    );

    if (!res) {
      throw new Error('Failed to retrieve pipeline launch details');
    }

    return res;
  }

  async readPipelineSchema(pipelineId: number, labId: string): Promise<DescribePipelineSchemaResponse> {
    const res = await httpClient.callSeqera<DescribePipelineSchemaResponse>(
      'GET',
      `/pipeline/read-pipeline-schema/${pipelineId}?laboratoryId=${labId}`,
    );

    if (!res) {
      throw new Error('Failed to retrieve pipeline schema');
    }

    validateApiResponse(PipelineSchemaResponseSchema, res);
    return res;
  }
}

export default SeqeraPipelinesModule;
